import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import moment from "moment";
import {
	adminBulkLocationUpdateStatus,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
	deleteComplianceReports,
	getComplianceReports,
} from "@services/reports.service";
import ConfigurePopup from "./popup/edit-popup";
import ScrollableReactTable from "@components/ScrollableDatatable";
import ReportsNotfound from "@components/Page-Not-Found/reports-not-found";
import MoreReportSvgComponent from "../../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";

interface IReportsLicenseProps {}

const ReportsVendorAudit: React.FunctionComponent<
	IReportsLicenseProps
> = (props: any) => {
	let navigate = useNavigate();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [isLoading, setIsLoading] = React.useState(true);
	const [list, setList] = React.useState<[]>([]);
	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getData();
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			getData();
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
		}
	}, [window.location.href, props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : limit,
			search_text: params.search_text,
			report_type: "VENDOR_AUDIT",
			// status: "active",
			sort_by: params.sort_by,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			setIsLoading(true);
			let resp = await getComplianceReports(queryRequest);
			if (resp) {
				setList(
					getValue(resp, `data.reports`, []).map((item: object) => ({
						...item,
						created_at: getValue(item, `created_at`, "")?moment(getValue(item, `created_at`, "")).format(
							"DD MMM YYYY"
						):'',
						status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
						generated_by:
							getValue(item, `user.first_name`, "") +
							" " +
							getValue(item, `user.last_name`, ""),
					}))
				);
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};
	const getDataRefetch = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : limit,
			search_text: params.search_text,
			report_type: "PE_COMPLIANCE",
			// status: "active",
			sort_by: params.sort_by,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			setIsLoading(true);
			let resp = await getComplianceReports(queryRequest);
			if (resp) {
				setList(
					getValue(resp, `data.reports`, []).map((item: object) => ({
						...item,
						created_at: moment(getValue(item, `created_at`, "")).format(
							"DD MMM YYYY"
						),
						status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
						generated_by:
							getValue(item, `user.first_name`, "") +
							" " +
							getValue(item, `user.last_name`, ""),
					}))
				);
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	const handleChangeSearch = async (e: any) => {
		setSearchInput(e.target.value);
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
		  ...params,
		  page_no: 1,
		  search_text: e.target.value,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
	};

	const [selectedIDs, setSelectedIDs] = useState<any>([]);
	const getTableState = (value: object) => {
		let selectedIndexList = Object.keys(
			getValue(value, `selectedRowIds`, {})
		).map((item) => parseInt(item));
		let selectedIds =
			list.length > 0
				? list.filter((_item: object, index: number) =>
						selectedIndexList.includes(index)
				  )
				: [];
		if (selectedIds.length > 0) {
			setSelectedIDs(
				selectedIds.map((item: object) => getValue(item, `id`, ""))
			);
		} else {
			setSelectedIDs([]);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeSortBy = (value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.sort_by = value;
		props.history.push({
			pathname: window.location.pathname,
			query: params,
		});
	};

	const handleChangeStatus = (value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.status = value;
		props.history.push({
			pathname: window.location.pathname,
			query: params,
		});
	};
	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(10);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			page_no: page_no,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload:any = {
			...params,
			limit:limit,
			page_no:'1'
		}
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleEdit = (id: string) => {
		navigate(`/add-clientlist/profile/${id}`);
	};
	const rowClick = (obj: object) => {
		// console.log(getValue(obj,`original`,''))
		navigate(`/report/vendor-audit/${getValue(obj, `original.id`, "")}`);
	};
	const getTrProps = (rowInfo: any) => {
		if (getValue(rowInfo, `id`, "")) {
			return {
				style: {
					//   background:  'red',
					//   color: 'black'
				},
			};
		}
		return {};
	};
	const columns = React.useMemo(
		() => [
			{
				Header: "Report Name",
				accessor: "report_name",
				width: 200,
				Cell: ({ row }: any) => {
					return (
						<NavLink to={`/report/vendor-audit/${row.original.id}`}>
							<>{row.values.report_name}</>
						</NavLink>
					);
				},
			},
			{
				Header: "Report Description",
				accessor: "report_description",
				width: 250,
			},
			{
				Header: "Generated By",
				accessor: "generated_by",
				width: 180,
			},
			{
				Header: "Generated On",
				accessor: "created_at",
				width: 150,
			},
			// {
			// 	Header: "Download",
			// 	width: 400,
			// 	Cell: ({ row }: any) => {
			// 		return (
			// 			!row.original.is_verified && (
			// 				<div className="d-flex">
			// 					{/* <button
			// 						className="resend-btn d-flex align-items-center"
			// 						onClick={(e) =>
			// 							handleDownloadOnClick(
			// 								getValue(row, `original.report_url`, ""),
			// 								getValue(row, `original.report_name`, "")
			// 							)
			// 						}
			// 						style={{ color: "#1A73E8" }}
			// 					>
			// 						<img
			// 							src="/images/download.svg"
			// 							className="img-fluid d-block"
			// 						/>
			// 						Download
			// 					</button> */}
			// 					{
			// 						 getValue(row, `original.is_scheduled`, "") ?
									
			// 						 <button
			// 						 className="resend-btn d-flex align-items-center"
									 
			// 						 style={{ color: "#1A73E8" }}
			// 					 >
			// 						 Scheduled
			// 					 </button>:
			// 					<button
			// 						className="resend-btn d-flex align-items-center"
			// 						onClick={(e) =>
			// 							handleEditPopup(e, getValue(row, `original.id`, ""))
			// 						}
			// 						style={{ color: "#1A73E8" }}
			// 					>
			// 						<img
			// 							src="/images/reports.svg"
			// 							className="img-fluid d-block"
			// 						/>
			// 						Schedule Report
			// 					</button>}
			// 				</div>
			// 			)
			// 		);
			// 	},
			// },
		],
		[]
	);

	const handleChangeActiveStatus = async (value: string) => {
		try {
			let resp = await adminBulkLocationUpdateStatus({
				ids: selectedIDs,
				is_active: value === "active" ? true : false,
			});
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				setSelectedIDs([]);
				getData();
			} else {
				getData();
			}
		} catch (error) {}
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	const [check, setCheck] = useState(false);
	const handleRemoveNavItems = () => {
		setCheck(!check);
		setSelectedIDs([]);
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Delete section                             */
	/* -------------------------------------------------------------------------- */

	const [deleteValue, setDeleteValue] = useState("");
	const [deleteId, setDeleteId] = useState("");
	const [isDelete, setIsDelete] = useState(false);

	const handleDeleteFun = (id: string, value: string) => {
		setDeleteValue(value);
		setDeleteId(id);
		handleDelete();
	};
	const handleDelete = () => {
		setIsDelete(!isDelete);
	};

	const handleDeleteFunction = async () => {
		try {
			let resp = await deleteComplianceReports({ ids: selectedIDs });
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				handleDelete();
				getData();
			}
		} catch (error) {}
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Modal section                             */
	/* -------------------------------------------------------------------------- */

	const [isOpen, setIsOpen] = useState(false);
	const handleModal = () => {
		setIsOpen(!isOpen);
	};
	const handleModalCancel = () => {
		handleModal();
	};
	const [configureID, setConfigureID] = useState<string>("");
	const handleEditPopup = (e: any, id: string) => {
		e.stopPropagation();
		if (id) {
			setIsOpen(!isOpen);
			setConfigureID(id);
		}
	};

	return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_analytics_vendor_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={false}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={false}
              handleRemoveNavItems={handleRemoveNavItems}
              delete
              handleDeleteFun={handleDeleteFun}
            />
          )}
          {/* <div className="dashboard-wrapper__header">
            <h4 className="dashbaord-wrapper__header-title">Vendor Audit</h4>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Vendor Audit
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                //search
				route={"/report/vendor-audit/add"}
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
				add={
					getValue(props, `permissions`, []).includes("create")
					  ? "true"
					  : "false"
				  }
                //Line Seperator of button
                lineSeperator={true}
				locationUpload={true}
              />
            </div>
          </div>
		  
		  <div
            className={`main-page-layout-wrapper`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
			<div className="admin-wrapper position-relative">
				<div className="admin-wrapper position-relative d-none">
				<SearchHeader
					route={"/report/vendor-audit/add"}
					searchInput={search_text}
					showSearchTextbox={showSearchTextbox}
					toggleSearch={toggleSearch}
					toggleSearchClose={toggleSearchClose}
					handleChangeSearch={handleChangeSearch}
					smartFilter={false}
					add={
					getValue(props, `permissions`, []).includes("create")
						? "true"
						: "false"
					}
					locationUpload={true}
				/>
				</div>
				{isLoading || !props.permissionAPITriggered ? (
				<Loader />
				) : list.length > 0 ? (
				<ScrollableReactTable
					columns={columns}
					data={list}
					getTableState={getTableState}
					rowClick={rowClick}
					check={check}
					selectedIDs={selectedIDs}
					getTrProps={getTrProps}
				/>
				) : (
				<>
					{Object.keys(params).length !== 0 ? (
					<>
						<ReportsNotfound route={"/report/vendor-audit/add"} />
					</>
					) : (
					<ReportsNotfound route={"/report/vendor-audit/add"} />
					)}
				</>
				)}
			</div>
			<div className="footer-wrapper d-flex justify-content-between">
				{list.length > 0 && (
				<img
					src="/images/building-illustration.svg"
					className="img-fluid"
				/>
				)}
				{totalCount > 10 ? (
				<PaginationPage
					totalCount={totalCount}
					limit={limit}
					pageNumber={page_no}
					handleChangePagination={handleChangePagination}
					handleChangeLimit={handleChangeLimit}
				/>
				) : (
				<p className="show-rows-count mt-3 d-flex">
					Total Count:&nbsp;&nbsp;{" "}
					<p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
				</p>
				)}
			</div>
			<DeleteModal
				isOpen={isDelete}
				handleModal={handleDelete}
				handleSubmit={handleDeleteFunction}
				deleteValue={deleteValue}
			/>
			{configureID && (
				<ConfigurePopup
				isOpen={isOpen}
				handleModal={handleModal}
				selectedIDs={selectedIDs}
				handleModalCancel={handleModalCancel}
				getDataRefetch={getDataRefetch}
				configureID={configureID}
				setConfigureID={setConfigureID}
				/>
			)}
		  </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ReportsVendorAudit;
